import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";

@Component({
  selector: "v4-base-selector-body",
  templateUrl: "./base-selector-body.component.html",
  styleUrls: ["./base-selector-body.component.scss"],
})
export class V4BaseSelectorBodyComponent implements OnInit, OnChanges {
  @Input() listOfOption: Option[] = [];
  @Input() listOfExtraOption: Option[] = [];
  @Input() mode: "single" | "multi" = "multi";
  @Input() showExtra = false;
  @Input() showFooter = true;
  @Input() selectedValues: number[];
  @Output() onSelect = new EventEmitter<Option[]>();
  @Output() onCancel = new EventEmitter();
  @Output() onConfirm = new EventEmitter<Option[]>();
  @Output() onReset = new EventEmitter();
  setOfSelectedOpts = new Set<number>();
  unfoldExtra = false;
  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes["listOfOption"]?.currentValue) {
    //   console.log("list of option: ");

    //   this.setOfSelectedOpts = new Set();
    // }
    if (changes["selectedValues"]?.currentValue) {
      this.setOfSelectedOpts = new Set(this.selectedValues);
    }
  }

  private mergeSelectedOpts() {
    const options = this.listOfOption.filter((opt) => this.setOfSelectedOpts.has(opt.value));
    const extraOptions = this.listOfExtraOption.filter((opt) => this.setOfSelectedOpts.has(opt.value));
    return [...options, ...extraOptions];
  }

  private triggerSelect() {
    const opts = this.mergeSelectedOpts();
    this.onSelect.emit(opts);
  }

  onSelectOption(opt: Option) {
    if (this.setOfSelectedOpts.has(opt.value)) {
      this.setOfSelectedOpts.delete(opt.value);
    } else {
      if (this.mode === "multi") {
        this.setOfSelectedOpts.add(opt.value);
      } else {
        this.setOfSelectedOpts = new Set([opt.value]);
      }
    }
    this.triggerSelect();

    console.log("setofselectedopts: ", this.setOfSelectedOpts);
  }

  onSelectAll() {
    this.setOfSelectedOpts = new Set(this.listOfOption.map((opt) => opt.value));
    this.triggerSelect();
  }

  onClickReset() {
    this.onReset.emit();
    // this.setOfSelectedOpts = new Set();
    // this.triggerSelect();
  }

  onClickCancel() {
    this.onCancel.emit();
  }

  onClickConfirm() {
    const options = this.mergeSelectedOpts();
    this.onConfirm.emit(options);
  }
}
